(() => {
  if (window.SweaterPromoProgressLoaded) return;
  window.SweaterPromoProgressLoaded = true;

  let collectionHandlesPromise;

  const getSweaterCollectionHandles = (root) => {
    if (!collectionHandlesPromise) {
      collectionHandlesPromise = (async () => {
        const handles = new Set();
        for (let page = 1; ; page += 1) {
          const response = await fetch(`${root}collections/sweaters/products.json?limit=250&page=${page}`, {
            credentials: 'same-origin',
          });
          if (!response.ok) throw new Error('Unable to load the Sweaters collection.');
          const collection = await response.json();
          const products = collection.products || [];
          products.forEach((product) => handles.add(product.handle));
          if (products.length < 250) break;
        }
        return handles;
      })().catch((error) => {
        collectionHandlesPromise = null;
        throw error;
      });
    }
    return collectionHandlesPromise;
  };

  class SweaterPromoProgress {
    constructor(element) {
      this.element = element;
      this.mode = element.dataset.mode || 'cart';
      this.isSweaterProduct = element.dataset.productEligible === 'true';
      this.cartCount = Number.parseInt(element.dataset.baseCount, 10) || 0;
      this.addedToCart = false;
      this.refreshTimer = null;
      this.quantityInput = this.mode === 'product'
        ? element.closest('.product-form')?.querySelector('.js-product-form [name="quantity"]')
        : null;

      this.handleQuantityChange = () => {
        this.addedToCart = false;
        this.scheduleRender();
      };
      this.handleQuantityButton = (event) => {
        if (!event.target.closest('.quantity-wrapper [data-quantity]')) return;
        this.addedToCart = false;
        this.scheduleRender();
      };
      this.handleCartChange = () => this.refreshCart();
      this.handleCartAdd = () => {
        if (this.mode === 'product') this.addedToCart = true;
        this.refreshCart();
      };

      if (this.quantityInput) {
        this.quantityInput.addEventListener('input', this.handleQuantityChange);
        this.quantityInput.addEventListener('change', this.handleQuantityChange);
        element.closest('.product-form')?.addEventListener('click', this.handleQuantityButton);
      }
      document.addEventListener('on:cart:after-merge', this.handleCartChange);
      document.addEventListener('on:cart:change', this.handleCartChange);
      document.addEventListener('on:cart:add', this.handleCartAdd);

      this.render();
      this.refreshCart();
    }

    scheduleRender() {
      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(() => this.render(), 0);
    }

    async refreshCart() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
        if (!response.ok) return;
        const cart = await response.json();
        const sweaterHandles = await getSweaterCollectionHandles(root);
        const eligibleQuantities = (cart.items || []).map((item) => (
          sweaterHandles.has(item.handle) ? Number(item.quantity || 0) : 0
        ));
        this.cartCount = eligibleQuantities.reduce((total, quantity) => total + quantity, 0);
        this.render();
      } catch (error) {
        this.render();
      }
    }

    render() {
      const message = this.element.querySelector('[data-sweater-promo-message]');
      const fill = this.element.querySelector('[data-sweater-promo-fill]');
      const selectedQuantity = this.quantityInput
        ? Math.max(1, Number.parseInt(this.quantityInput.value, 10) || 1)
        : 1;
      const pendingQuantity = this.mode === 'product' && this.isSweaterProduct && !this.addedToCart
        ? selectedQuantity
        : 0;
      const total = this.cartCount + pendingQuantity;

      if (message) {
        if (total >= 3) {
          message.innerHTML = "You've unlocked <strong>30% off</strong> your sweaters.";
        } else if (total === 2) {
          message.innerHTML = 'Add one more sweater to unlock <strong>30% off</strong>.';
        } else if (total === 1) {
          message.innerHTML = 'Add one more sweater to unlock <strong>25% off</strong>.';
        } else {
          message.innerHTML = 'Add a sweater to unlock <strong>15% off</strong>.';
        }
      }

      this.element.querySelectorAll('[data-sweater-promo-tier]').forEach((tier) => {
        const threshold = Number.parseInt(tier.dataset.sweaterPromoTier, 10);
        tier.classList.toggle('is-active', total >= threshold);
      });

      if (fill) fill.style.width = `${Math.min(100, Math.max(0, (total - 1) * 50))}%`;
    }
  }

  const initialize = () => {
    document.querySelectorAll('[data-sweater-promo-progress]').forEach((element) => {
      if (!element.__sweaterPromoProgress) {
        element.__sweaterPromoProgress = new SweaterPromoProgress(element);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
